import { G as e, H as o } from "../../vendor-EQDp64ng.js";
import { Content as r } from "./Content/index.js";
import { Header as t } from "./Header/index.js";
import { Item as i } from "./Item/index.js";
import { Section as a } from "./Section/index.js";
import { Separator as m } from "./Separator/index.js";
import { Label as p, Description as c, DecorationRight as n, DecorationLeft as f } from "../ItemRow/index.js";
const L = Object.assign({
  Item: i,
  Content: r,
  Header: t,
  ItemDecorationLeft: f,
  ItemDecorationRight: n,
  ItemDescription: c,
  ItemLabel: p,
  Section: a,
  Separator: m,
  SubTrigger: o,
  Trigger: e
});
export {
  L as DropdownMenu
};
